import { render, staticRenderFns } from "./Compose.OptionsPanel.vue?vue&type=template&id=ebcdf35e&scoped=true&"
import script from "./Compose.OptionsPanel.vue?vue&type=script&lang=js&"
export * from "./Compose.OptionsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcdf35e",
  null
  
)

export default component.exports